import { Track } from '../types';

// Static fallback used until /api/tracks responds (or if it fails).
// Mirrors the seed data in api/src/data/tracks.json.
export const DEFAULT_TRACKS: Track[] = [
  {
    id: 'threat-protection-security-operations',
    name: 'Threat Protection & Security Operations',
    description:
      'Master email security, endpoint protection, cloud app security, and SIEM/SOAR with Microsoft Defender XDR and Sentinel. Aligned to SC-200 and SC-401.',
    icon: '\u{1F6E1}',
    color: '#059669',
    sortOrder: 1,
  },
  {
    id: 'identity-access-microsoft-entra',
    name: 'Identity & Access — Microsoft Entra',
    description:
      'Deploy phishing-resistant authentication, Conditional Access, and Zero Trust network access with Entra ID and Global Secure Access. Aligned to SC-300.',
    icon: '\u{1F510}',
    color: '#2563eb',
    sortOrder: 2,
  },
  {
    id: 'device-endpoint-management',
    name: 'Device & Endpoint Management',
    description:
      'Build enterprise Intune deployments from enrollment through compliance, Conditional Access enforcement, and KQL-based monitoring. Aligned to MD-102.',
    icon: '\u{1F4BB}',
    color: '#0f766e',
    sortOrder: 3,
  },
  {
    id: 'data-security-compliance',
    name: 'Data Security & Compliance',
    description:
      'Implement sensitivity labels, encryption, DLP enforcement, and Copilot data protection with Microsoft Purview. Aligned to SC-400.',
    icon: '\u{1F512}',
    color: '#7c3aed',
    sortOrder: 4,
  },
  {
    id: 'advanced-automation-api-engineering',
    name: 'Advanced Automation & API Engineering',
    description:
      'Secure service principals, build credential-free automation, and deploy security tools with Graph API, Azure Functions, and azd. Aligned to SC-200 and SC-300.',
    icon: '⚙',
    color: '#d97706',
    sortOrder: 5,
  },
];

export const FALLBACK_TRACK_ICON = '\u{1F393}';
export const FALLBACK_TRACK_COLOR = '#6b7280';

// Courses store the track name, so lookups are by name. Unknown names get a
// neutral placeholder rather than breaking the UI.
export const findTrackByName = (tracks: Track[], name: string): Track =>
  tracks.find((track) => track.name === name) ?? {
    id: '',
    name,
    description: '',
    icon: FALLBACK_TRACK_ICON,
    color: FALLBACK_TRACK_COLOR,
    sortOrder: Number.MAX_SAFE_INTEGER,
  };
